import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetsDriverRoutingModule } from './assets-driver-routing.module';
import { AssetDriverListComponent } from './assets-driver-list/asset-driver-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { AssetDriverListViewComponent } from './assets-driver-list/asset-driver-list-view/asset-driver-list-view.component';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AssetDriverDetailComponent } from './asset-driver-detail/asset-driver-detail.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { RequestsModule } from '../my-requests/requests.module';
import { IconsModule } from '@progress/kendo-angular-icons';
import { AssetsModule } from '../my-assets/assets.module';

@NgModule({
  imports: [
    CommonModule,
    AssetsDriverRoutingModule,
    TranslateModule.forChild(),
    ComponentsModule,
    DateInputsModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    InputsModule,
    NgbModule,
    QRCodeComponent,
    RequestsModule,
    IconsModule,
    AssetsModule,
  ],
  declarations: [AssetDriverListComponent, AssetDriverListViewComponent, AssetDriverDetailComponent],
})
export class AssetsDriverModule {}
